import React, { useEffect, useRef, useState, useContext } from "react";
import {
  LowerWrapperBannerBlock,
  ContainerIteration,
  GeneralStyle,
  UpperWrapperBannerBlock,
  EditSectionBannerBlock,
  QuestionWrapperBannerBlock,
  SelectsSectionBannerBlock,
  ContainerButtons,
  ContainerTitle,
  ReqField,
  ContainerImgBanner,
  ImgBanner,
  EditButton,
  DeleteButton,
} from "./BannerBlock.styled";
import {
  StyledButton,
  StyledButtonGenericQuestion,
} from "../../containers/SurveyPreviewPanel/SurveyPreviewPanel.styled";
import StyleQuestionContainer from "../../containers/StyleQuestionContainer/index";
import UploadImage from "../UploadImage/UploadImage";
import MessageYesNo from "../MessageYesNo/index";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { ReactComponent as DeleteQuestion } from "../../themes/Icons/delete-question.svg";
import { ReactComponent as CancelQuestion } from "../../themes/Icons/cancel-question.svg";
import { ReactComponent as StyleQuestion } from "../../themes/Icons/style-question.svg";
import EditorConvertToMarkdown from "../EditorConvertToMarkdown";

const BannerBlock = (props) => {
  const [stateQuestionsReducer] = useContext(ContextQuestions);
  const rCategory = useRef();
  const [colorBackground] = useState("#f9f9f9");
  const [showStyleEdit, setshowStyleEdit] = useState(false);
  const [, setSelectedFile] = useState(null);
  const [imgBanner, setImgBanner] = useState("");
  const [nameImgBanner, setNameImgBanner] = useState("");
  const [openMessageYesNoModal, setOpenMessageYesNoModal] = useState(false);
  const [responseMessageYesNo, setResponse] = useState(false);

  useEffect(() => {
    setImgBanner("");
    if (props.urlPreviewImage) {
      setImgBanner(props.urlPreviewImage);
    }
  }, [props.urlPreviewImage]);

  useEffect(() => {
    if (responseMessageYesNo) {
      props.handleDeleteQuestion();
    }
  }, [responseMessageYesNo]);

  let handleImgBanner = (type, item, urlPreviewImage) => {
    props.setSelectedFiles([item[0]]);
    setSelectedFile(item[0]);
    props.setNameSelectedFile(item[0].name);
    setNameImgBanner(item[0].name);
    setImgBanner(urlPreviewImage);
  };

  useEffect(() => {
    if (props.title) props.setRefTitle(props.title);
  }, [props.title]);

  let handleRefCategory = (e) => {
    props.setRefCategory(e.target.value);
  };

  const selectedColorBackground = props.configQuestionStyle.customStyle
    ? props.configQuestionStyle.background
    : colorBackground;

  let showEditSection = (editable) => {
    return editable ? (
      <EditSectionBannerBlock>
        <UpperWrapperBannerBlock>
          <QuestionWrapperBannerBlock>
            {/* <UploadImage displayNameButton="Add Image" setFile={handleImgBanner} nameFile={nameImgBanner}></UploadImage> */}
            <UploadImage
              displayNameButton="Add Image"
              setFile={handleImgBanner}
            ></UploadImage>

            <br />
            <label>Add Text:</label>
            <EditorConvertToMarkdown
              editor={props.title}
              setEditor={props.setTitle}
              style={{ width: "100%" }}
            />
            {!props.title && <ReqField>*</ReqField>}
          </QuestionWrapperBannerBlock>
          <SelectsSectionBannerBlock>
            <div>
              <label>Category</label>
              <select
                onChange={(e) => handleRefCategory(e)}
                ref={rCategory}
                defaultValue={props.refCategory.toString()}
              >
                <option value={0}>- Category -</option>
                {props.loadCategories()}
              </select>
              {props.refCategory === 0 || props.refCategory === "" ? (
                <ReqField>*</ReqField>
              ) : null}
            </div>
          </SelectsSectionBannerBlock>
        </UpperWrapperBannerBlock>
      </EditSectionBannerBlock>
    ) : null;
  };

  let showImgBanner = () => {
    return imgBanner ? (
      <ContainerIteration
        style={
          props.configQuestionStyle.customStyle
            ? props.configQuestionStyle.answer
            : stateQuestionsReducer.globalStyle.answers
        }
      >
        <ContainerImgBanner
          color={
            props.configQuestionStyle.customStyle
              ? props.configQuestionStyle.background
              : colorBackground
          }
        >
          <ImgBanner
            src={imgBanner}
            alt={nameImgBanner}
            crossorigin="anonymous"
          />
        </ContainerImgBanner>
      </ContainerIteration>
    ) : null;
  };

  let showTitle = (title) => {
    return title ? (
      <LowerWrapperBannerBlock>
        <ContainerTitle>
          <div
            style={{
              wordBreak: "normal",
              padding: "0 0 14px 0",
              width: "500px",
              overflowY: "auto",
            }}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </ContainerTitle>
      </LowerWrapperBannerBlock>
    ) : null;
  };

  let showEditButtons = (editable) => {
    return (
      editable && (
        <ContainerButtons>
          <div className="left-container">
            <StyledButtonGenericQuestion
              onClick={() => {
                setshowStyleEdit(true);
              }}
            >
              <StyleQuestion />
              Style
            </StyledButtonGenericQuestion>
            {editable && props.idQuestionSurvey ? (
              <StyledButtonGenericQuestion onClick={() => props.handleCancel()}>
                <CancelQuestion />
                Cancel
              </StyledButtonGenericQuestion>
            ) : null}
            <StyledButtonGenericQuestion
              lastElement={true}
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              <DeleteQuestion />
              Delete
            </StyledButtonGenericQuestion>
          </div>
          <div className="right-container">
            <StyledButton onClick={() => props.saveQuestionBank()}>
              Save
            </StyledButton>
          </div>
        </ContainerButtons>
      )
    );
  };

  return (
    <GeneralStyle
      editable={props.editable}
      colorBackground={selectedColorBackground}
    >
      {showEditSection(props.editable)}
      {showImgBanner()}

      {showTitle(props.title)}
      {!props.editable && props.idQuestionSurvey && (
        <div className="overlay-option">
          <div className="bottom-buttons">
            <DeleteButton
              className="mx-3 w-25 mt-2 mb-3"
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              Delete
            </DeleteButton>
            <EditButton
              className="mx-3 w-25 mt-2 mb-3"
              onClick={() => props.handleEdit()}
            >
              Edit
            </EditButton>
          </div>
        </div>
      )}
      {showEditButtons(props.editable)}
      {showStyleEdit && (
        <StyleQuestionContainer
          setshowStyleEdit={setshowStyleEdit}
          stateObject={props.configQuestionStyle}
          setstateObject={props.setconfigQuestionStyle}
        ></StyleQuestionContainer>
      )}
      {openMessageYesNoModal && (
        <MessageYesNo
          setOpenMessageYesNoModal={setOpenMessageYesNoModal}
          message="Are you sure you want to delete this question?"
          setResponse={setResponse}
        ></MessageYesNo>
      )}
    </GeneralStyle>
  );
};

export default BannerBlock;
